<template>
  <div class="upload-container">
    <a-upload
      :multiple="multiple"
      class="avatar-uploader"
      :accept="acceptType"
      :showUploadList="false"
      :action="actionUrl"
      :fileList="fileList"
      :beforeUpload="beforeUpload"
    >
      <slot></slot>
    </a-upload>
    <div class="over-layer" v-if="!multiple && uploadLoading"></div>
  </div>
</template>
<script>
import UploadCore from './md5-core';
export default {
  name: 'UpfileButton',
  props: {
    multiple: {
      default: false
    },
    value: {
      default: ''
    },
    acceptType: {
      type: String
    },
    fileSizeInKB: {
      type: Number,
      default: 51200 // 50M
    },
    handleBeforeUpload: {
      type: Function
    },
    handleSuccess: {
      type: Function
    },
    handleDone: {
      type: Function
    },
    handleError: {
      type: Function
    },
    handleProgress: {
      type: Function
    },
    getAttachmentIdFlag: {
      type: Boolean,
      default: false
    },
    md5: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      actionUrl: '',
      uploadLoading: false,
      fileList: [],
      imgUrl: ''
      // uploading
    };
  },
  watch: {
    value(val) {
      this.imgUrl = val;
    }
  },
  methods: {
    beforeUpload(file, fileList) {
      this.$emit('beforeUpload', file, fileList);
      console.log('选择的文件->', file, fileList);
      const fileSize = file.size / 1024; //KB
      let mark = true; //判断上传
      if (fileSize > this.fileSizeInKB) {
        this.$message.error('文件不能大于' + this.fileSizeInKB / 1024 + 'MB');
        mark = false;
      } else if (this.acceptType && this.acceptType.indexOf(file.type) <= -1) {
        // this.$message.error('请上传 ' + this.acceptType + ' 格式的文件！', 10);
        this.$message.error('上传文件的格式不正确！', 10);
        mark = false;
      }
      // 文件开始上传
      if (this.handleBeforeUpload) {
        let handleBeforeMark = this.handleBeforeUpload(file, fileList, mark);
        if (!handleBeforeMark) mark = false;
      }
      this.imgUrl = '';
      //每选择一个文件会触发一次该方法，所以通过判断fileList的更改来调用上传
      if (this.fileList !== fileList && mark) {
        this.fileList = fileList;
        this.uploadLoading = true;
        this.handleUpload();
      }
      return false;
    },

    handleUpload() {
      const { fileList } = this;
      let upload = new UploadCore(this.getAttachmentIdFlag, this.md5);
      upload.uploadFileList(
        fileList,
        list => {
          this.uploadLoading = false;
          this.$emit('input', list[0].__remoteUrl);
          this.imgUrl = list[0].__remoteUrl;
          // console.trace('所有文件上传结束！', list);
          this.handleDone && this.handleDone(Array.from(list));
          // 删除已上传文件，防止重复上传
          this.fileList.length = 0;
        },
        async (err, file) => {
          //console.log('单文件上传结束！', err, file);
          if (err) {
            this.handleError && this.handleError(err, file);
            return this.$message.error('上传失败！' + err.message);
          } else {
            this.handleSuccess && this.handleSuccess([file]);
          }
        },
        (event, file) => {
          this.handleProgress && this.handleProgress(event, file);
          file.percent =
            Math.floor((event.loaded / event.total) * 100 * 100) / 100;
        }
      );
    }
  }
};
</script>

<style lang="stylus" scoped>
.upload-container
  position relative
  .over-layer
    position absolute
    top 0
    bottom 0
    left 0
    right 0
    z-index 1
</style>